export class FiadoFormaPagamentoUtils {
  private static normalize(valor: any): string {
    return String(valor || '').trim().toLowerCase();
  }

  static formaPermitidaParaRecebimento(forma: any): boolean {
    if(!forma || forma.online) return false;
    if(forma.fiado === true) return false;

    const nome = this.normalize(forma?.nome);
    const descricao = this.normalize(forma?.descricao);
    const tipoPdv = this.normalize(forma?.formaDePagamentoPdv?.tipo);

    if(nome.startsWith('ifood') || nome.startsWith('keeta') ||  nome.startsWith('99food'))
      return false;

    if(nome.includes('cashback') || descricao.includes('cashback')) return false;
    if(nome.includes('fiado') || descricao.includes('fiado')) return false;
    if(nome.includes('resgate') || descricao.includes('resgate')) return false;
    if(nome.includes('fidelidade') || descricao.includes('fidelidade')) return false;
    if(tipoPdv === 'fidelidade') return false;

    return true;
  }
}
